//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'clean',
  components: {
  },
  data () {
    return {
      type:10,
      count:{
        all:0,
        member:0,
        wait:0,
        expired:0,
      },
    }
  },
  created(){
   
  },
  mounted(){
    this.getCountMember();

  },
  methods:{
    getCountMember(){
      this.$api.getCountMember({}).then((res)=>{
        this.count = res.data;
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/card.vue